/*
 * @Author: edvardchen
 * @Date: 2017-08-21 15:12:22
 * @Last Modified by: edvardchen
 * @Last Modified time: 2017-08-21 15:22:39
 */
import querystring from 'query-string';

// @flow
export default function singleContentQBUrl({ url = '', cid = '', ch = '', docId = '', mttsummaryid = '' }): string {
  const params = {
    contenturl: url,
    type: 3,
    mttsummaryid: docId || mttsummaryid,
    bizid: 1,
    b_f: ch,
  };

  return `qb://ext/read?cid=${cid}&${querystring.stringify(params)}`;
}
